$(document).ready(function(){

  //   $(".cstm_cart_add").click(function(e){
  //     e.preventDefault();

  //     if($('.la_dleivery_btns > ul > li.la-delivery-day-active').length){
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         data:$(".product-single__meta .product-form").serialize(),

  //         dataType: 'json',
  //         success: function(response){
  //           $.ajax({
  //             type: 'GET',
  //             url: '/cart.js',
  //             dataType: 'json',
  //             success: function(cartdata){

  //               if(cartdata.item_count >= 1) {
  //                 $('#CartCount').attr('style','display: block !important');
  //               }

  //               $('.site-header__cart #CartCount').html(cartdata.item_count);

  //               $.ajax({
  //                 type: "GET",
  //                 url: "/cart",
  //                 dataType: 'html',
  //                 success: function(data){
  //                   var minicartdata = $(data).filter('#slidingcartmain').html();
  //                   $('#slidingcartmain').html(minicartdata);  
  //                   $("#overlay").addClass("is-active");
  //                   $(".inline-cart").addClass("is-active");
  //                   $('body').addClass('cstm_toggle_cls'); 
  //                 }
  //               });
  //             }
  //           });
  //         },
  //         error: function(resp){
  //           var getres = JSON.stringify(resp);
  //           alert(resp.responseJSON.description);
  //         }
  //       });
  //     }
  //     else{
  //       alert('oo');
  //       alert($('.la_dleivery_btns > ul > li.la-delivery-day-active').length);
  //     }
  //   });

  document.addEventListener("zrx-slider-item-added", function (e) {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cartdata){

        if(cartdata.item_count >= 1) {
          $('#CartCount').attr('style','display: block !important');
        }

        $('.site-header__cart #CartCount').html(cartdata.item_count);

        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',
          success: function(data){
            var minicartdata = $(data).filter('#slidingcartmain').html();
            $('#slidingcartmain').html(minicartdata);  
            $("#overlay").addClass("is-active");
            $(".inline-cart").addClass("is-active");
            $('body').addClass('cstm_toggle_cls');
          }
        });
      }
    });    
  });

  $(".site-header__cart").click(function(e){
    e.preventDefault();
    $("#overlay").addClass("is-active");
    $(".inline-cart").addClass("is-active");
    $("body").addClass("la-cart-drawyer-mn-open");
  });

  $('.top_header_new_cart').click(function(){
    $('body').addClass('cstm_toggle_cls');   
  });

  $("#overlay").click(function(){
    $('body').removeClass('cstm_toggle_cls');  
  });

  $(".close-cart-img").click(function(){
    $('body').removeClass('cstm_toggle_cls');  
  });

//   $('html').click(function(){
//     $("body").removeClass("la-cart-drawyer-mn-open");
//   });

  $(".close-cart-img").click(function(){
    $(".inline-cart").removeClass("is-active"); 
    $("#overlay").removeClass("is-active");
    $("body").removeClass("la-cart-drawyer-mn-open");
  });  

});

$(window).ready(function(){
  $('body').on('click', '.close-cart-img', function(e){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('cstm_toggle_cls'); 
    $("body").removeClass("la-cart-drawyer-mn-open");
  });

  $('body').on('click', '.continueshopping', function(e){
    e.preventDefault();
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $("body").removeClass("la-cart-drawyer-mn-open");
  });

  $('body').on('click', '#overlay', function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $("body").removeClass("la-cart-drawyer-mn-open");
  });

});

$(document).ready(function(){

  $("body").on("click", ".qtyplus", function() {
    var t = +$(this).siblings(".changequantity").val() + 1;
    $(this).siblings(".changequantity").val(t)
  }), $("body").on("click", ".qtyminus", function() {
    var t = +$(this).siblings(".changequantity").val() - 1;
    t < 0 && (t = 0), $(this).siblings(".changequantity").val(t)
  }),
    $(document).ready(function() {
    $("body").on("click", ".qtyplus, .qtyminus", function() {
      var t = $(this).siblings(".changequantity").attr("data-line-item-index"),
          a = $(this).siblings(".changequantity").val();
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + a + "&line=" + t,
        dataType: "json",
        success: function(t) {
          t.item_count, $(".site-header__cart #CartCount").html(t.item_count), $.ajax({
            type: "GET",
            url: "/cart",
            dataType: "html",
            success: function(t) {
              console.log("syncCart");
              var a = $(t).filter("#slidingcartmain").html();
              $("#slidingcartmain").html(a), $("#overlay").addClass("is-active"), $(".inline-cart").addClass("is-active")
            }
          })
        }
      })
    })
  })

  $('body').on('change', '.changequantity', function(){
    var getline = $(this).attr("data-line-item-index");
    console.log(getline);
    var getval = $(this).val();
    console.log(getval);
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + getval + '&line=' + getline,
      dataType: 'json',
      success: function(data) {
        if(data.item_count > 0){
          $('.site-header__cart #CartCount').html(data.item_count);  
          var value_get = $(".BOLD-mc-picker > .currentCurrency .name").html();
          $(".currency-dropdown-option.option[data-value='"+value_get+"']").trigger("click");  
        } else {
          $('.site-header__cart #CartCount').html(data.item_count) ;  
          var value_get = $(".BOLD-mc-picker > .currentCurrency .name").html();
          $(".currency-dropdown-option.option[data-value='"+value_get+"']").trigger("click");  
        }

        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',
          success: function(data) {
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            var value_get = $(".BOLD-mc-picker > .currentCurrency .name").html();
            $(".currency-dropdown-option.option[data-value='"+value_get+"']").trigger("click");  
            $("#overlay").addClass("is-active");
            $(".inline-cart").addClass("is-active");

          }
        })
      }
    })

  })

  $('body').on('click', '.product-add-con button', function(e) {
    e.preventDefault();
    var Variantsget = $(this).parents(".product-add-con").attr("data-idget");
    Variantsget = parseInt(Variantsget);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+ Variantsget,
      dataType: 'json',
      success: function(data){
        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',
          success: function(data) {
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            var countget=$(data).find('.cart_count_items').html();
            $('.cart_count_items').html(countget);
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);

          }
        })
      }
    })	
  })

})
// function remove(line, quantity){
//   $.ajax({
//     type: 'POST',
//     url: '/cart/change',
//     data: 'quantity='+quantity+'&line='+line,
//     dataType: 'json',
//     success: function(response){
//       $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function(cartdata){
//           $('.site-header__cart #CartCount').html(cartdata.item_count);
//           $.ajax({
//             type: "GET",
//             url: "/cart",
//             dataType: 'html',
//             success: function(data) 
//             {
//               var minicartdata=$(data).filter('#slidingcartmain').html();
//               $('#slidingcartmain').html(minicartdata);
//               console.log("COMPLETE");
//               var value_get = $(".BOLD-mc-picker > .currentCurrency .name").html();
//               $(".currency-dropdown-option.option[data-value='"+value_get+"']").trigger("click");  

//             }
//           });

//         }
//       });

//     }
//   });
// }

function removeproduct(line, quantity){
  $.ajax({
    type: 'POST',
    url: '/cart/change',
    data: 'quantity='+quantity+'&line='+line,
    dataType: 'json',
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata){
          $('.site-header__cart #CartCount').html(cartdata.item_count);
          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: 'html',
            success: function(data) {
              var countget = $(data).find('.cart_count_items').html();
              var divLength = $(data).find('.cart_count_items').length;
              $('.cart_count_items').html(countget);
              if(divLength==0){
                $('.cart_count_items').remove();
                location.reload();
              }
              else{
                $('.cart_count_items').show();
                location.reload();
              }
              var minicartdata = $(data).filter('#slidingcartmain').html();

            }
          });
        }
      });
    }
  });
}
